"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIdentityStitchesResult = exports.IdentityStitchDto = exports.GetIdentityLookupResult = exports.CreateIdentityLookupResult = exports.IdentityLookupDto = exports.SetIdentityTagsResult = exports.SetIdentityTagsPayload = exports.UpdateIdentityResult = exports.UpdateIdentityPayload = exports.GetIdentityResult = exports.IdentityDetailDto = exports.IdentityScanRowDto = exports.BulkUpdateIdentitiesResult = exports.BulkUpdateIdentitiesPayload = exports.GetIdentityTagsResult = exports.IdentityTagCountDto = exports.GetIdentitiesResult = exports.IdentityStatsDto = exports.IdentityListFilterDto = exports.IdentityListRow = exports.IdentityMetaDto = exports.IdentityCustomField = void 0;
const class_validator_1 = require("class-validator");
const base_get_result_dto_1 = require("../../../../common/dtos/base-get-result.dto");
class IdentityCustomField {
}
__decorate([
    (0, class_validator_1.IsString)()
], IdentityCustomField.prototype, "key", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityCustomField.prototype, "value", void 0);
exports.IdentityCustomField = IdentityCustomField;
/** The contact details integrations match people on, plus custom pairs. */
class IdentityMetaDto {
}
__decorate([
    (0, class_validator_1.IsArray)()
], IdentityMetaDto.prototype, "custom", void 0);
exports.IdentityMetaDto = IdentityMetaDto;
class IdentityListRow {
}
__decorate([
    (0, class_validator_1.IsString)()
], IdentityListRow.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityListRow.prototype, "codename", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityListRow.prototype, "originCode", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], IdentityListRow.prototype, "absorbedIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], IdentityListRow.prototype, "codeIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], IdentityListRow.prototype, "tags", void 0);
__decorate([
    (0, class_validator_1.IsObject)()
], IdentityListRow.prototype, "meta", void 0);
exports.IdentityListRow = IdentityListRow;
/**
 * The list's narrowing — every member optional, ANDed together. The same
 * shape drives the page, the count, and the bulk update, so "edit the
 * 43 in view" edits exactly the 43 the page was counted from.
 */
class IdentityListFilterDto {
}
exports.IdentityListFilterDto = IdentityListFilterDto;
/** Org-wide figures for the list's tiles — never narrowed by the filter. */
class IdentityStatsDto {
}
exports.IdentityStatsDto = IdentityStatsDto;
class GetIdentitiesResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetIdentitiesResult.prototype, "identities", void 0);
exports.GetIdentitiesResult = GetIdentitiesResult;
/** Tags in use across the organization's identities, with counts. */
class IdentityTagCountDto {
}
__decorate([
    (0, class_validator_1.IsString)()
], IdentityTagCountDto.prototype, "tag", void 0);
exports.IdentityTagCountDto = IdentityTagCountDto;
class GetIdentityTagsResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetIdentityTagsResult.prototype, "tags", void 0);
exports.GetIdentityTagsResult = GetIdentityTagsResult;
/** One change applied to every identity the filter matches. */
class BulkUpdateIdentitiesPayload {
}
__decorate([
    (0, class_validator_1.IsObject)()
], BulkUpdateIdentitiesPayload.prototype, "filter", void 0);
exports.BulkUpdateIdentitiesPayload = BulkUpdateIdentitiesPayload;
class BulkUpdateIdentitiesResult extends base_get_result_dto_1.BaseGetResult {
}
exports.BulkUpdateIdentitiesResult = BulkUpdateIdentitiesResult;
/** One scan in an identity's own ledger — code fields decorate client-side. */
class IdentityScanRowDto {
}
__decorate([
    (0, class_validator_1.IsString)()
], IdentityScanRowDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityScanRowDto.prototype, "at", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityScanRowDto.prototype, "codeId", void 0);
exports.IdentityScanRowDto = IdentityScanRowDto;
class IdentityDetailDto extends IdentityListRow {
}
__decorate([
    (0, class_validator_1.IsArray)()
], IdentityDetailDto.prototype, "scans", void 0);
exports.IdentityDetailDto = IdentityDetailDto;
class GetIdentityResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], GetIdentityResult.prototype, "identity", void 0);
exports.GetIdentityResult = GetIdentityResult;
/** Partial: only the provided members change. */
class UpdateIdentityPayload {
}
__decorate([
    (0, class_validator_1.IsObject)()
], UpdateIdentityPayload.prototype, "meta", void 0);
exports.UpdateIdentityPayload = UpdateIdentityPayload;
class UpdateIdentityResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], UpdateIdentityResult.prototype, "identity", void 0);
exports.UpdateIdentityResult = UpdateIdentityResult;
class SetIdentityTagsPayload {
}
__decorate([
    (0, class_validator_1.IsArray)()
], SetIdentityTagsPayload.prototype, "tags", void 0);
exports.SetIdentityTagsPayload = SetIdentityTagsPayload;
class SetIdentityTagsResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], SetIdentityTagsResult.prototype, "tags", void 0);
exports.SetIdentityTagsResult = SetIdentityTagsResult;
/** A "Who am I?" handshake, as the dashboard sees it. */
class IdentityLookupDto {
}
__decorate([
    (0, class_validator_1.IsString)()
], IdentityLookupDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityLookupDto.prototype, "token", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityLookupDto.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityLookupDto.prototype, "expiresAt", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityLookupDto.prototype, "status", void 0);
exports.IdentityLookupDto = IdentityLookupDto;
class CreateIdentityLookupResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], CreateIdentityLookupResult.prototype, "lookup", void 0);
exports.CreateIdentityLookupResult = CreateIdentityLookupResult;
class GetIdentityLookupResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], GetIdentityLookupResult.prototype, "lookup", void 0);
exports.GetIdentityLookupResult = GetIdentityLookupResult;
class IdentityStitchDto {
}
__decorate([
    (0, class_validator_1.IsString)()
], IdentityStitchDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityStitchDto.prototype, "kind", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityStitchDto.prototype, "at", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], IdentityStitchDto.prototype, "summary", void 0);
exports.IdentityStitchDto = IdentityStitchDto;
class GetIdentityStitchesResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetIdentityStitchesResult.prototype, "stitches", void 0);
exports.GetIdentityStitchesResult = GetIdentityStitchesResult;
